export const ComTxProtocol = {
  txSignin: '/tx/signin',
  //txParticipationIn: '/tx/participation/in',
  //txParticipationOut: '/tx/participation/out',
  //txParticipationEject: '/tx/participation/eject',
  txParticipation: '/tx/participation',
  txEntry: '/tx/entry',
  txEntryOrder: '/tx/entry/order',
  txEntryCancel: '/tx/entry/cancel',
  txNoticeUpdate: '/tx/notice/update',
  txEntrySiteUpdate: '/tx/entry-site/update',
} as const;
export type ComTxProtocol = (typeof ComTxProtocol)[keyof typeof ComTxProtocol];

export const ComPushProtocol = {
  //pushParticipationIn: '/push/participation/in',
  //pushParticipationOut: '/push/participation/out',
  //pushEject: '/push/eject',
  pushParticipation: '/push/participation',
  pushEntry: '/push/entry',
  pushEntryOrder: '/push/entry/order',
  pushEntryCancel: '/push/entry/cancel',
  pushAutoSort: '/push/auto-sort',
  pushNoticeUpdate: '/push/notice/update',
  pushEntrySiteUpdate: '/push/entry-site/update',
} as const;
export type ComPushProtocol =
  (typeof ComPushProtocol)[keyof typeof ComPushProtocol];
